import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../core';
import { UsuarioExpedicao } from '../expedicao';

@Injectable({
    providedIn: 'root'
})
export class UsuarioExpedicaoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/usuario`;
    }

    /** Pesquisa todos os usuários expedição do usuário pai informado */
    search(idUsuarioPai: number, situacao: number = null): Observable<UsuarioExpedicao[]> {
        // Params
        let params = new HttpParams();
        // Situação
        if (situacao) {
            params = params.append('situacao', situacao.toString());
        }

        return this.customHttp.get<UsuarioExpedicao[]>(`${this.pathApi}/${idUsuarioPai}/expedicao`, {params});
    }
}
